import ComponentWithSocket from '../../lib/component'
import { Component } from 'vue-property-decorator';

import template from './account.vue';

import * as Store from './../../store';

interface AccountData {
    editAccountInfo: boolean;
    editName: boolean;
    theLots: any;
    theUser: any;
    verification?: any;
    activeList: string;
}

@Component({
    mixins: [template]
})

export default class UserAccount extends ComponentWithSocket {

    data: AccountData = {
        editAccountInfo: false,
        editName: false,
        theLots: {},
        theUser: {},
        verification: undefined,
        activeList: 'won'
    }

    constructor() {

        super()

        this.wsListener.onGet('auth.profile', (success: boolean, data: any) => {
            if (success) {
                this.data.theUser = data.profile;
                this.data.verification = data.verification
                Store.commitLoaderVisibility(this.$store, false);
            }
            else {

            }
        });

        this.wsListener.onGet('auth.lots', (success: boolean, data: any) => {
            this.data.theLots = data;
        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {
        this.wsListener.sendGet('auth.profile');
        this.wsListener.sendGet('auth.lots', { won: true });
    }

    getWonList() {

        this.data.activeList = 'won';
        this.wsListener.sendGet('auth.lots', { won: true });

    }

    getBiddedList() {

        this.data.activeList = 'bidded';
        this.wsListener.sendGet('auth.lots', { bidded: true });

    }

    getLikedList() {

        this.data.activeList = 'liked';
        this.wsListener.sendGet('auth.lots', { liked: true });

    }

    uploadNewAvatar() {
        let input: any = document.getElementById('new-profile-pic'),
            $this: any = this;

        if (input.files && input.files[0]) {

            let FR = new FileReader();

            FR.addEventListener('load', function(e: any) {
                $this.data.theUser.avatarUrl = e.target.result;
            });

            FR.readAsDataURL( input.files[0] );

        }
    }

    doSaveSettings() {

        this.data.editName = false;
        this.data.editAccountInfo = false;

        let $this = this;

        this.wsListener.sendPost('auth.profile', {
            firstName: $this.data.theUser.firstName,
            lastName: $this.data.theUser.lastName,
            email: $this.data.theUser.email,
            phone: $this.data.theUser.phone,
            avatar: $this.data.theUser.avatarUrl
        });

    }

    doEditName() {
        this.data.editName = !this.data.editName;
    }

    goToRoute(theRoute: string) {

        if (this.$root.$options && this.$root.$options.router) {

            this.$root.$options.router.push(theRoute);

        }

    }

    doLogout() {

        Store.commitLoggedInState(this.$store, false);
        Store.commitLoggedInUser(this.$store, {});

        this.wsListener.setAuthState(false)

        this.wsListener.reconnect(() => {
            this.goToRoute('/login')
        })

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/account/index.ts